// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as firebase from 'firebase'
import $ from 'jquery'
import Datatable from 'vue2-datatable-component'
import Nav from './components/Admin/Partial/Nav'
import PageHeader from './components/Admin/Partial/PageHeader'
import Preloader from './components/Admin/Partial/Preloader'

// Dependencies
import 'materialize-css/dist/css/materialize.css'
import 'materialize-css/dist/js/materialize.js'
import 'muicss/dist/css/mui.min.css'
import 'muicss/dist/js/mui.min.js'
import _ from 'lodash'
import 'datatables.net'

// App config
var config = require('../app.config.json')
window.app = Vue.prototype.app = config.app

// Firebase
firebase.initializeApp(config.firebase[config.app.env]);

// Router guard
router.beforeEach( (to, from, next) => {
  let excludedRoutes = ['Home', 'SignIn', 'NotFound']
  let isDirectAccess = !from.name

  // Remove tooltips
  $('.tooltipped').tooltip('remove')

  firebase.auth()
  .onAuthStateChanged(user => {

    // Auth user can go any page
    if (user) return next()

    // Restrict unauth access
    else {
      if (isDirectAccess && !_.includes(excludedRoutes, to.name)) return next('/')
      next()
    }
  })
})

// External components
Vue.use(Datatable)

// Components
Vue.component('admin-nav', Nav)
Vue.component('page-header', PageHeader)
Vue.component('preloader', Preloader)
Vue.prototype._ = _

// Event Bus
Vue.prototype.$bus = new Vue();

// Vue confi
Vue.config.productionTip = false
Vue.config.ignoredElements = ['root']

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js